export default "__VITE_ASSET__BQmh5700__"